/* ══════════════════════════════════════
   MECA Custom Jersey Order Form
   Multi-Design Support (Home/Away/Alt)
   assets/custom-jerseys.js
   ══════════════════════════════════════ */

(function () {
  'use strict';

  // ── Config ──
  var PRICE_PER_SET = 40;
  var VARIANT_ID = 43140839931994;

  var SIZES = [
    'Youth Small', 'Youth Medium', 'Youth Large',
    'Adult Small', 'Adult Medium', 'Adult Large',
    'Adult XL', 'Adult 2XL'
  ];

  // ── State ──
  var currentStep = 1;
  var totalSteps = 5; // Design → Add More? → Quantity → Roster → Review

  // Multiple designs array
  var designs = [];
  var editingDesignIndex = -1; // -1 means adding new

  // ── DOM refs ──
  var form = document.getElementById('jerseyOrderForm');
  var steps = document.querySelectorAll('.jersey-form-step');
  var indicators = document.querySelectorAll('.jersey-step');
  var btnBack = document.getElementById('btnBack');
  var btnContinue = document.getElementById('btnContinue');
  var btnCheckout = document.getElementById('btnCheckout');
  var checkoutError = document.getElementById('checkoutError');

  // Step 1 — Design
  var typeRadios = document.querySelectorAll('input[name="jersey_type"]');
  var typeOptions = document.querySelectorAll('.jersey-type-option');
  var teamNameInput = document.getElementById('teamName');
  var colorInput = document.getElementById('colorVariant');
  var designLabelInput = document.getElementById('designLabel');
  var descInput = document.getElementById('designDescription');
  var uploadArea = document.getElementById('uploadArea');
  var fileInput = document.getElementById('conceptArt');
  var fileNameEl = document.getElementById('uploadFileName');

  // Step 2 — Design Summary / Add More
  var designsList = document.getElementById('designsList');
  var btnAddDesign = document.getElementById('btnAddDesign');

  // Step 3 — Quantity
  var quantityInput = document.getElementById('quantity');
  var priceSummary = document.getElementById('priceSummary');
  var summaryQty = document.getElementById('summaryQty');
  var summaryTotal = document.getElementById('summaryTotal');
  var quantityNote = document.getElementById('quantityNote');

  // Step 4 — Roster
  var includeNames = document.getElementById('includeNames');
  var rosterBody = document.getElementById('rosterBody');

  // ── Helpers ──
  function formatDollars(amount) {
    return '$' + amount.toFixed(2);
  }

  // ── Step navigation ──
  function goToStep(step) {
    currentStep = step;

    steps.forEach(function (el, i) {
      el.style.display = (i + 1 === step) ? 'block' : 'none';
    });

    indicators.forEach(function (el, i) {
      var s = i + 1;
      el.className = 'jersey-step';
      if (s < step) el.classList.add('complete');
      else if (s === step) el.classList.add('active');
      else el.classList.add('pending');
    });

    btnBack.style.display = step > 1 ? 'inline-block' : 'none';
    btnContinue.style.display = step < totalSteps ? 'inline-block' : 'none';
    btnCheckout.style.display = step === totalSteps ? 'inline-block' : 'none';
    checkoutError.style.display = 'none';

    // Update continue button text
    if (step === 1) {
      btnContinue.innerHTML = 'Continue &rarr;';
    } else {
      btnContinue.innerHTML = 'Continue &rarr;';
    }

    // Step 2: render designs list
    if (step === 2) renderDesignsList();

    // Step 3: update quantity note
    if (step === 3) updateQuantityNote();

    // Step 5: populate review
    if (step === 5) populateReview();

    var indicator = document.getElementById('stepIndicator');
    if (indicator) {
      indicator.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ── Save current design from form ──
  function saveDesignFromForm() {
    var typeEl = document.querySelector('input[name="jersey_type"]:checked');
    var design = {
      type: typeEl ? typeEl.value : '',
      typeLabel: typeEl ? (typeEl.value === 'pre-designed' ? 'Pre-Designed' : 'To Be Designed') : '',
      teamName: teamNameInput.value.trim(),
      color: colorInput.value.trim(),
      label: designLabelInput ? designLabelInput.value.trim() : '',
      description: descInput.value.trim(),
      fileName: fileInput.files.length ? fileInput.files[0].name : ''
    };

    if (editingDesignIndex >= 0) {
      designs[editingDesignIndex] = design;
      editingDesignIndex = -1;
    } else {
      designs.push(design);
    }
  }

  // ── Clear design form for new entry ──
  function clearDesignForm() {
    // Keep team name (shared across designs)
    colorInput.value = '';
    if (designLabelInput) designLabelInput.value = '';
    descInput.value = '';
    fileInput.value = '';
    fileNameEl.style.display = 'none';
    fileNameEl.textContent = '';

    // Reset type selection
    typeRadios.forEach(function (r) { r.checked = false; });
    typeOptions.forEach(function (o) { o.classList.remove('selected'); });

    editingDesignIndex = -1;
  }

  // ── Load design into form for editing ──
  function loadDesignToForm(index) {
    var d = designs[index];
    teamNameInput.value = d.teamName;
    colorInput.value = d.color;
    if (designLabelInput) designLabelInput.value = d.label || '';
    descInput.value = d.description;

    // Set type radio
    typeRadios.forEach(function (r, i) {
      if (r.value === d.type) {
        r.checked = true;
        typeOptions[i].classList.add('selected');
      } else {
        r.checked = false;
        typeOptions[i].classList.remove('selected');
      }
    });

    // File can't be restored, just show name
    if (d.fileName) {
      fileNameEl.textContent = d.fileName;
      fileNameEl.style.display = 'block';
    } else {
      fileNameEl.style.display = 'none';
    }

    editingDesignIndex = index;
  }

  // ── Render designs list (Step 2) ──
  function renderDesignsList() {
    designsList.innerHTML = '';

    designs.forEach(function (d, i) {
      var label = d.label || ('Design ' + (i + 1));
      var card = document.createElement('div');
      card.className = 'design-card';
      card.innerHTML =
        '<div style="flex:1;">' +
          '<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">' +
            '<span style="font-size:15px;font-weight:700;color:var(--text-primary);">' + label + '</span>' +
            '<span style="font-size:10px;padding:2px 8px;background:var(--brand-subtle);color:var(--brand);border-radius:4px;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;">' + d.typeLabel + '</span>' +
          '</div>' +
          '<div style="font-size:12px;color:var(--text-muted);">' + d.teamName + ' &middot; ' + d.color + '</div>' +
          '<div style="font-size:12px;color:var(--text-secondary);margin-top:4px;max-width:400px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + d.description + '</div>' +
        '</div>' +
        '<div style="display:flex;gap:8px;align-items:center;flex-shrink:0;">' +
          '<button type="button" class="btn-edit-design" data-index="' + i + '" style="font-size:12px;color:var(--brand);font-weight:600;background:none;border:none;cursor:pointer;padding:4px 8px;">Edit</button>' +
          (designs.length > 1 ? '<button type="button" class="btn-remove-design" data-index="' + i + '" style="font-size:12px;color:#ef4444;font-weight:600;background:none;border:none;cursor:pointer;padding:4px 8px;">Remove</button>' : '') +
        '</div>';

      designsList.appendChild(card);
    });

    // Bind edit/remove buttons
    document.querySelectorAll('.btn-edit-design').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.dataset.index);
        loadDesignToForm(idx);
        goToStep(1);
      });
    });

    document.querySelectorAll('.btn-remove-design').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.dataset.index);
        designs.splice(idx, 1);
        renderDesignsList();
      });
    });
  }

  // ── Update quantity note ──
  function updateQuantityNote() {
    if (quantityNote) {
      if (designs.length > 1) {
        quantityNote.textContent = 'This is per player — each player gets ' + designs.length + ' jersey sets (' + designs.map(function (d) { return d.label || d.color; }).join(', ') + '). Total cost = quantity × ' + designs.length + ' × $' + PRICE_PER_SET + '.';
      } else {
        quantityNote.textContent = 'Each set includes jersey + shorts.';
      }
    }
  }

  // ── Quantity input handler ──
  quantityInput.addEventListener('input', function () {
    var qty = parseInt(quantityInput.value, 10);
    if (qty > 0) {
      var totalSets = qty * designs.length;
      var totalPrice = totalSets * PRICE_PER_SET;
      priceSummary.style.display = 'block';
      summaryQty.textContent = totalSets + ' (' + qty + ' players × ' + designs.length + ' design' + (designs.length > 1 ? 's' : '') + ')';
      summaryTotal.textContent = formatDollars(totalPrice);
      hideError('errorQuantity');
    } else {
      priceSummary.style.display = 'none';
    }
  });

  // ── Validation ──
  function hideError(id) {
    var el = document.getElementById(id);
    if (el) el.style.display = 'none';
  }

  function showError(id, msg) {
    var el = document.getElementById(id);
    if (el) {
      if (msg) el.textContent = msg;
      el.style.display = 'block';
    }
  }

  function validateStep1() {
    var valid = true;
    var typeSelected = document.querySelector('input[name="jersey_type"]:checked');
    if (!typeSelected) { showError('errorJerseyType'); valid = false; } else { hideError('errorJerseyType'); }
    if (!teamNameInput.value.trim()) { showError('errorTeamName'); valid = false; } else { hideError('errorTeamName'); }
    if (!colorInput.value.trim()) { showError('errorColorVariant'); valid = false; } else { hideError('errorColorVariant'); }
    if (!descInput.value.trim()) { showError('errorDesignDesc'); valid = false; } else { hideError('errorDesignDesc'); }
    return valid;
  }

  function validateStep3() {
    var qty = parseInt(quantityInput.value, 10);
    if (!qty || qty < 1 || qty > 100) { showError('errorQuantity'); return false; }
    hideError('errorQuantity');
    return true;
  }

  function validateStep4() {
    var rows = rosterBody.querySelectorAll('tr');
    var valid = true;
    rows.forEach(function (row) {
      var numInput = row.querySelector('.roster-number');
      var sizeSelect = row.querySelector('.roster-size');
      if (!numInput.value.trim()) { numInput.classList.add('input-error'); valid = false; } else { numInput.classList.remove('input-error'); }
      if (!sizeSelect.value) { sizeSelect.classList.add('input-error'); valid = false; } else { sizeSelect.classList.remove('input-error'); }
    });
    if (!valid) showError('errorRoster'); else hideError('errorRoster');
    return valid;
  }

  function validateCurrentStep() {
    switch (currentStep) {
      case 1: return validateStep1();
      case 2: return true; // designs list always valid if we got here
      case 3: return validateStep3();
      case 4: return validateStep4();
      default: return true;
    }
  }

  // ── Jersey type selection ──
  typeRadios.forEach(function (radio, index) {
    radio.addEventListener('change', function () {
      typeOptions.forEach(function (opt) { opt.classList.remove('selected'); });
      typeOptions[index].classList.add('selected');
      hideError('errorJerseyType');
    });
  });

  // ── File upload ──
  uploadArea.addEventListener('click', function () { fileInput.click(); });
  uploadArea.addEventListener('dragover', function (e) {
    e.preventDefault();
    uploadArea.style.borderColor = 'var(--brand)';
    uploadArea.style.background = 'var(--brand-subtle)';
  });
  uploadArea.addEventListener('dragleave', function () {
    uploadArea.style.borderColor = '';
    uploadArea.style.background = '';
  });
  uploadArea.addEventListener('drop', function (e) {
    e.preventDefault();
    uploadArea.style.borderColor = '';
    uploadArea.style.background = '';
    if (e.dataTransfer.files.length) {
      fileInput.files = e.dataTransfer.files;
      showFileName(e.dataTransfer.files[0]);
    }
  });
  fileInput.addEventListener('change', function () {
    if (fileInput.files.length) showFileName(fileInput.files[0]);
  });

  function showFileName(file) {
    var sizeMB = (file.size / (1024 * 1024)).toFixed(1);
    fileNameEl.textContent = file.name + ' (' + sizeMB + ' MB)';
    fileNameEl.style.display = 'block';
  }

  // ── Roster generation ──
  function generateRoster(qty) {
    var existingData = collectRosterData();
    rosterBody.innerHTML = '';

    for (var i = 0; i < qty; i++) {
      var tr = document.createElement('tr');
      tr.style.verticalAlign = 'top';

      var tdNum = document.createElement('td');
      tdNum.style.cssText = 'padding:4px 8px 4px 0;color:var(--text-muted);font-size:12px;padding-top:12px;';
      tdNum.textContent = i + 1;
      tr.appendChild(tdNum);

      var tdJersey = document.createElement('td');
      tdJersey.style.padding = '4px 8px';
      var jerseyInput = document.createElement('input');
      jerseyInput.type = 'text';
      jerseyInput.className = 'roster-input roster-number';
      jerseyInput.placeholder = '##';
      jerseyInput.maxLength = 3;
      jerseyInput.style.maxWidth = '70px';
      if (existingData[i] && existingData[i].number) jerseyInput.value = existingData[i].number;
      jerseyInput.addEventListener('input', function () { this.classList.remove('input-error'); });
      tdJersey.appendChild(jerseyInput);
      tr.appendChild(tdJersey);

      var tdFullName = document.createElement('td');
      tdFullName.style.padding = '4px 8px';
      var fullNameInput = document.createElement('input');
      fullNameInput.type = 'text';
      fullNameInput.className = 'roster-input roster-fullname';
      fullNameInput.placeholder = 'Player name';
      if (existingData[i] && existingData[i].fullName) fullNameInput.value = existingData[i].fullName;
      tdFullName.appendChild(fullNameInput);
      tr.appendChild(tdFullName);

      var tdBackText = document.createElement('td');
      tdBackText.className = 'backtext-col';
      tdBackText.style.padding = '4px 8px';
      tdBackText.style.display = includeNames.checked ? '' : 'none';
      var backTextInput = document.createElement('input');
      backTextInput.type = 'text';
      backTextInput.className = 'roster-input roster-name';
      backTextInput.placeholder = 'SMITH, nickname, etc.';
      if (existingData[i] && existingData[i].name) backTextInput.value = existingData[i].name;
      tdBackText.appendChild(backTextInput);
      tr.appendChild(tdBackText);

      var tdSize = document.createElement('td');
      tdSize.style.padding = '4px 0 4px 8px';
      var sizeSelect = document.createElement('select');
      sizeSelect.className = 'roster-input roster-size';
      var defaultOpt = document.createElement('option');
      defaultOpt.value = '';
      defaultOpt.textContent = 'Select size';
      sizeSelect.appendChild(defaultOpt);
      SIZES.forEach(function (size) {
        var opt = document.createElement('option');
        opt.value = size;
        opt.textContent = size;
        if (existingData[i] && existingData[i].size === size) opt.selected = true;
        sizeSelect.appendChild(opt);
      });
      sizeSelect.addEventListener('change', function () { this.classList.remove('input-error'); });
      tdSize.appendChild(sizeSelect);
      tr.appendChild(tdSize);

      rosterBody.appendChild(tr);
    }
  }

  function collectRosterData() {
    var data = [];
    var rows = rosterBody.querySelectorAll('tr');
    rows.forEach(function (row) {
      data.push({
        number: (row.querySelector('.roster-number') || {}).value || '',
        fullName: (row.querySelector('.roster-fullname') || {}).value || '',
        name: (row.querySelector('.roster-name') || {}).value || '',
        size: (row.querySelector('.roster-size') || {}).value || ''
      });
    });
    return data;
  }

  // ── Player name toggle ──
  includeNames.addEventListener('change', function () {
    var show = includeNames.checked;
    document.querySelectorAll('.backtext-col').forEach(function (el) { el.style.display = show ? '' : 'none'; });
    rosterBody.querySelectorAll('.backtext-col').forEach(function (el) { el.style.display = show ? '' : 'none'; });
  });

  // ── Add another design button ──
  btnAddDesign.addEventListener('click', function () {
    clearDesignForm();
    // Keep team name from first design
    if (designs.length > 0) {
      teamNameInput.value = designs[0].teamName;
    }
    goToStep(1);
  });

  // ── Review population ──
  function populateReview() {
    var qty = parseInt(quantityInput.value, 10) || 0;
    var totalSets = qty * designs.length;
    var totalPrice = totalSets * PRICE_PER_SET;
    var roster = collectRosterData();
    var showBackText = includeNames.checked;

    // Designs summary
    var reviewDesigns = document.getElementById('reviewDesigns');
    reviewDesigns.innerHTML = '';

    designs.forEach(function (d, i) {
      var label = d.label || ('Design ' + (i + 1));
      var div = document.createElement('div');
      div.style.cssText = 'background:#f9f8f5;border-radius:var(--radius-sm);padding:16px;font-size:13px;line-height:1.8;color:var(--text-secondary);margin-bottom:8px;';
      div.innerHTML =
        '<div style="font-size:14px;font-weight:700;color:var(--text-primary);margin-bottom:4px;">' + label + '</div>' +
        '<div><strong style="color:var(--text-primary);">Team:</strong> ' + d.teamName + '</div>' +
        '<div><strong style="color:var(--text-primary);">Type:</strong> ' + d.typeLabel + '</div>' +
        '<div><strong style="color:var(--text-primary);">Colors:</strong> ' + d.color + '</div>' +
        '<div><strong style="color:var(--text-primary);">Description:</strong> ' + d.description + '</div>' +
        (d.fileName ? '<div><strong style="color:var(--text-primary);">Concept Art:</strong> ' + d.fileName + '</div>' : '');
      reviewDesigns.appendChild(div);
    });

    // Roster table
    document.querySelectorAll('.review-backtext-col').forEach(function (el) { el.style.display = showBackText ? '' : 'none'; });
    var reviewBody = document.getElementById('reviewRosterBody');
    reviewBody.innerHTML = '';
    var sizeCounts = {};

    roster.forEach(function (entry, i) {
      var tr = document.createElement('tr');
      tr.className = 'review-roster-row';
      tr.innerHTML =
        '<td>' + (i + 1) + '</td>' +
        '<td style="font-weight:700;">#' + entry.number + '</td>' +
        '<td>' + (entry.fullName || '—') + '</td>' +
        (showBackText ? '<td class="review-backtext-col" style="font-weight:700;">' + (entry.name || '—') + '</td>' : '') +
        '<td>' + entry.size + '</td>';
      reviewBody.appendChild(tr);
      if (entry.size) sizeCounts[entry.size] = (sizeCounts[entry.size] || 0) + 1;
    });

    // Size breakdown
    var breakdownEl = document.getElementById('sizeBreakdown');
    breakdownEl.innerHTML = '';
    SIZES.forEach(function (size) {
      if (sizeCounts[size]) {
        var badge = document.createElement('span');
        badge.className = 'size-badge';
        badge.innerHTML = '<strong>' + sizeCounts[size] + '</strong> ' + size;
        breakdownEl.appendChild(badge);
      }
    });

    // Totals
    document.getElementById('reviewQtyLabel').textContent = qty + ' players × ' + designs.length + ' design' + (designs.length > 1 ? 's' : '') + ' = ' + totalSets + ' sets';
    document.getElementById('reviewTotal').textContent = formatDollars(totalPrice);
  }

  // ── Nav button handlers ──
  btnContinue.addEventListener('click', function () {
    if (!validateCurrentStep()) return;

    // Step 1 → save design, go to step 2
    if (currentStep === 1) {
      saveDesignFromForm();
      goToStep(2);
      return;
    }

    // Step 3 → generate roster
    if (currentStep === 3) {
      var qty = parseInt(quantityInput.value, 10);
      generateRoster(qty);
    }

    goToStep(currentStep + 1);
  });

  btnBack.addEventListener('click', function () {
    // From step 2, go back to editing the last design
    if (currentStep === 2) {
      loadDesignToForm(designs.length - 1);
      goToStep(1);
      return;
    }
    goToStep(currentStep - 1);
  });

  // ── Checkout ──
  btnCheckout.addEventListener('click', function () {
    btnCheckout.classList.add('loading');
    btnCheckout.textContent = 'Adding to cart...';
    checkoutError.style.display = 'none';

    var qty = parseInt(quantityInput.value, 10);
    var roster = collectRosterData();

    // Build one line item per design, each with the same roster
    var items = designs.map(function (d, di) {
      var label = d.label || ('Design ' + (di + 1));
      var properties = {
        'Design': label,
        'Team Name': d.teamName,
        'Jersey Type': d.typeLabel,
        'Color Variant': d.color,
        'Design Description': d.description,
        'Total Sets': String(qty),
        'Designs in Order': String(designs.length)
      };

      if (d.fileName) properties['Concept Art'] = d.fileName;
      if (includeNames.checked) properties['Includes Back Text'] = 'Yes';

      // Attach roster to each design
      roster.forEach(function (entry, i) {
        var prefix = 'Jersey ' + (i + 1);
        properties[prefix + ' - Size'] = entry.size;
        properties[prefix + ' - Number'] = entry.number;
        if (entry.fullName) properties[prefix + ' - Player Name'] = entry.fullName;
        if (includeNames.checked && entry.name) properties[prefix + ' - Back Text'] = entry.name;
      });

      return {
        id: VARIANT_ID,
        quantity: qty,
        properties: properties
      };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Failed to add to cart. Please try again.');
      return response.json();
    })
    .then(function () {
      window.location.href = '/checkout';
    })
    .catch(function (err) {
      btnCheckout.classList.remove('loading');
      btnCheckout.textContent = 'Proceed to Checkout';
      checkoutError.textContent = err.message || 'Something went wrong. Please try again.';
      checkoutError.style.display = 'block';
    });
  });

  // ── Clear input errors on interaction ──
  teamNameInput.addEventListener('input', function () { hideError('errorTeamName'); });
  colorInput.addEventListener('input', function () { hideError('errorColorVariant'); });
  descInput.addEventListener('input', function () { hideError('errorDesignDesc'); });

  // ── Initialize ──
  goToStep(1);

})();
